import { Factory, trait } from 'miragejs';

export default Factory.extend({
  name: null,
  notes: null,
  enabled: true,
  shouldCreateUtilization: true,

  asAssignedDesk: trait({
    afterCreate(feature, server) {
      const desk = feature.deskId ? server.schema.desks.find(feature.deskId) : server.schema.desks.find(feature.id);
      const gqlMapFloor = server.schema['graphql/mapFloors'].first();
      const gqlMapFeature = server.create('graphql/map-feature', {
        type: 'DESK',
        floor: gqlMapFloor,
        name: desk.name,
      });
      const mapFeature = server.schema.mapFeatures.find(gqlMapFeature.id);

      const assignedEmployee = server.schema['graphql/employees'].first();
      const utilization = server.create('graphql/desk-utilization', { percentUtilized: 0.5 });

      mapFeature.update({
        externalId: desk.id,
      });

      const gqlDesk = server.create('graphql/desk', {
        name: desk.name,
        mapFeature: gqlMapFeature,
        assignedEmployee,
        utilization,
        deskAvailability: 'userAssigned',
      });

      feature.update({
        type: 'desk',
        id: mapFeature.id,
        name: desk.name,
        desk: gqlDesk,
      });
    },
  }),

  asHotelDesk: trait({
    afterCreate(feature, server) {
      const desk = feature.deskId ? server.schema.desks.find(feature.deskId) : server.schema.desks.find(feature.id);
      const gqlMapFloor = server.schema['graphql/mapFloors'].first();
      const gqlMapFeature = server.create('graphql/map-feature', {
        type: 'DESK',
        floor: gqlMapFloor,
        name: desk.name,
      });
      const mapFeature = server.schema.mapFeatures.find(gqlMapFeature.id);

      mapFeature.update({
        externalId: desk.id,
      });

      const gqlDesk = server.create('graphql/desk', {
        name: desk.name,
        mapFeature: gqlMapFeature,
        assignedEmployee: null,
        deskAvailability: 'userAssigned',
        shouldCreateUtilization: feature.shouldCreateUtilization,
      });

      feature.update({
        type: 'desk',
        id: mapFeature.id,
        name: desk.name,
        desk: gqlDesk,
      });
    },
  }),
});
